import { useQueryClient, useMutation } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import { assistantHistoryQueryKey } from "ai/hooks/constants";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const triggerRequest = (request) => fetch("POST", qualifyUrl("/plugins/org.graylog.plugins.assistant/assistant"), request);
const useAskAssistant = () => {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
    error
  } = useMutation({
    mutationFn: triggerRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: assistantHistoryQueryKey
      });
    },
    onError: (e) => UserNotification.error(e.message)
  });
  return {
    request: mutateAsync,
    isLoading,
    isError,
    error
  };
};
export default useAskAssistant;
